import { ReactElement, useId } from 'react'
import { Label } from 'app/components/ui/label'
import { Switch } from 'app/components/ui/switch'

type Props = {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}

export function InternalOnlySwitch({ checked, onCheckedChange }: Props): ReactElement {
  const id = useId()
  return (
    <div className="flex items-center gap-2">
      <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} />
      <Label htmlFor={id}>Trackable staff only</Label>
    </div>
  )
}
